import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const LogoutUser: React.FC = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggingOut) {
      const rememberMe = localStorage.getItem("rememberMe") === "true";
      
      if (rememberMe) {
        const savedEmail = localStorage.getItem("email");
        const savedPassword = localStorage.getItem("password");
        const rememberMeStatus = localStorage.getItem("rememberMe");
        
        localStorage.clear();
        
        localStorage.setItem("email", savedEmail || "");
        localStorage.setItem("password", savedPassword || "");
        localStorage.setItem("rememberMe", rememberMeStatus || "true");
      } else {
        localStorage.clear();
      }
      
      navigate("/");
    }
  }, [isLoggingOut, navigate]);

  const handleLogout = () => {
    setIsLoggingOut(true);
  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false);
    navigate(-1); 
  };

  return (
    <>
      <Modal
        show={showConfirmationModal}
        onHide={handleCloseModal}
        className="remove-popup"
      >
        <div className="modal-in">
          <Modal.Header closeButton>
            <Modal.Title>Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to log out?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-primary"
              onClick={handleLogout}
              disabled={isLoggingOut}
              style={{ backgroundColor: "#20396E", color: "white" }}
            >
              {isLoggingOut ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Yes"
              )}
            </Button>
            <Button
              className="btn btn-outline-secondary"
              onClick={handleCloseModal}
              style={{
                border: "1px solid #3C6DB2",
                backgroundColor: "white",
                color: "#20396E",
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default LogoutUser;
